import Offcanvas from "react-bootstrap/Offcanvas";

import { Badge, Grid } from "@nextui-org/react";
import { Input } from "@chakra-ui/react";
import "./drawerTaskNotidy.css";
import React, { useEffect, useState } from "react";
import ModalEditTask from "../modalEditTask/modalEditTask";
import axios from "axios";

import DeeletNotifybtn from "../deleteNotifyBTN/deleteNotifyBTN";
import { Avatar, AvatarBadge, AvatarGroup } from '@chakra-ui/react'
import { useSelector } from "react-redux";
import "./drawerTaskNotidyDark.css"
import { Navigate, useNavigate } from "react-router";
import sockets from "../../../../socket/socket";
const socket = sockets;
export default function DrawerTaskNotiify({
  mynotify,
  lengthNotify,
  update,
  handleGetNotify,
  item,
  index
}) {
  const [show, setShow] = useState(false);
  const getDarkModoe = useSelector(darkModes => darkModes)
  const navigate = useNavigate()


  // здесь мы подтверждаем дату или статус
  const handleDelete = () => {
       
              
        
    axios.post("/handleDelete/api", {
      itemID: item._id,
    })
    .then(function (response) {
      
      socket.emit("getNotifyEmit");
    
    })
    .catch(function (error) {
      console.log(error);
     
    });
};

  const handleApply = (e) => {
    console.log(e,"eee");

    if (e.typenotify === "date" && e.isChild === "false") {
      e.alltask[0][0].alltask[0].endDate = e.messageConfirm;
      let idTask = e.alltask[0][0]._id;
      let alltask = e.alltask[0][0].alltask;
      console.log(e.alltask[0][0]);

      axios
        .post("/handleapply/api", {
          idTask: idTask,
          alltask: alltask,
          pushItemID: e._id,
          adminID: e.adminIDTask,
          senderEmail: e.senderEmail,
          isChild:e.isChild,
          index:0,
          task:alltask = e.alltask[0][0]
        })
        .then(function (response) {
          console.log(response);
          socket.emit("getNotifyEmit");
          socket.emit('getallTaskforUpdateServer');
           handleDelete()
          update();
        })
        .catch(function (error) {
          console.log(error);
        });
    } else if (e.typenotify === "status" && e.isChild === "false") {
      e.alltask[0][0].alltask[0].status = "Принята";
      let idTask = e.alltask[0][0]._id;
      let alltask = e.alltask[0][0].alltask;

      axios
        .post("/handleapply/api", {
          idTask: idTask,
          alltask: alltask,
          pushItemID: e._id,
          adminID: e.adminIDTask,
          senderEmail: e.senderEmail,
          isChild:e.isChild,
          index:0,
          task:alltask = e.alltask[0][0]
        })
        .then(function (response) {
          console.log(response);
          socket.emit("getNotifyEmit");
          socket.emit('getallTaskforUpdateServer');
          handleDelete()
          update();
        })
        .catch(function (error) {
          console.log(error);
        });
    }
    else if (e.typenotify === "date" && e.isChild === "true") {
      e.alltask[0][0].alltask[0].child[e.indexTask].endDate = e.messageConfirm
      let idTask = e.alltask[0][0]._id;
      let alltask = e.alltask[0][0].alltask;
      axios
        .post("/handleapply/api", {
          idTask: idTask,
          alltask: alltask,
          pushItemID: e._id,
          adminID: e.adminIDTask,
          senderEmail: e.senderEmail,
          isChild:e.isChild,
          index:e.indexTask,
          task:alltask = e.alltask[0][0]
        })
        .then(function (response) {
          console.log(response);
          socket.emit("getNotifyEmit");
          socket.emit('getallTaskforUpdateServer');
          handleDelete()
          update();
        })
        .catch(function (error) {
          console.log(error);
        });
    }
    else if (e.typenotify === "status" && e.isChild === "true") {
      e.alltask[0][0].alltask[0].child[e.indexTask].status = "Принята"
      let idTask = e.alltask[0][0]._id;
      let alltask = e.alltask[0][0].alltask;
      axios
        .post("/handleapply/api", {
          idTask: idTask,
          alltask: alltask,
          pushItemID: e._id,
          adminID: e.adminIDTask,
          senderEmail: e.senderEmail,
          isChild:e.isChild,
          index:e.indexTask,
          task:alltask = e.alltask[0][0]
        })
        .then(function (response) {
          console.log(response);
          socket.emit("getNotifyEmit");
          socket.emit('getallTaskforUpdateServer');
          // handleDelete()
          update();
        })
        .catch(function (error) {
          console.log(error);
        });
    }

  };

  // с детьми отменяем дату или статус
  const handleCanhel = (e) => {

    if (e.typenotify === "date" && e.isChild === "false") {
      e.alltask[0][0].alltask[0].endDate = e.oldDate;
      let idTask = e.alltask[0][0]._id;
      let alltask = e.alltask[0][0].alltask;

      console.log(e.alltask[0][0].alltask[0].endDate);
      axios
        .post("/handleCanchel/api", {
          idTask: idTask,
          alltask: alltask,
          pushItemID: e._id,
          adminID: e.adminIDTask,
          senderEmail: e.senderEmail,
          isChild:e.isChild,
          index:0,
          task:alltask = e.alltask[0][0]
        })
        .then(function (response) {
          socket.emit("getNotifyEmit");
          socket.emit('getallTaskforUpdateServer');
          // handleDelete()
          update();
        })
        .catch(function (error) {
          console.log(error);
        });
    } else if (e.typenotify === "status" && e.isChild === "false") {
      e.alltask[0][0].alltask[0].status = "Возвращена";
      let idTask = e.alltask[0][0]._id;
      let alltask = e.alltask[0][0].alltask;

      console.log(e.alltask[0][0].alltask[0].endDate);
      axios
        .post("/handleCanchel/api", {
          idTask: idTask,
          alltask: alltask,
          pushItemID: e._id,
          adminID: e.adminIDTask,
          senderEmail: e.senderEmail,
          isChild:e.isChild,
          index:0,
          task:alltask = e.alltask[0][0]
        })
        .then(function (response) {
          socket.emit("getNotifyEmit");
          socket.emit('getallTaskforUpdateServer');
          // handleDelete()
          update();
        })
        .catch(function (error) {
          console.log(error);
        });
    }
    else if (e.typenotify === "date" && e.isChild === "true") {
      e.alltask[0][0].alltask[0].child[e.indexTask].endDate = e.oldDate
      let idTask = e.alltask[0][0]._id;
      let alltask = e.alltask[0][0].alltask;
      axios
        .post("/handleCanchel/api", {
          idTask: idTask,
          alltask: alltask,
          pushItemID: e._id,
          adminID: e.adminIDTask,
          senderEmail: e.senderEmail,
          isChild:e.isChild,
          index:e.indexTask,
          task:alltask = e.alltask[0][0]
        })
        .then(function (response) {
          console.log(response);
          socket.emit("getNotifyEmit");
          socket.emit('getallTaskforUpdateServer');
          // handleDelete()
          update();
        })
        .catch(function (error) {
          console.log(error);
        });
    }
    else if (e.typenotify === "status" && e.isChild === "true") {
      e.alltask[0][0].alltask[0].child[e.indexTask].status = "Возвращена"
      let idTask = e.alltask[0][0]._id;
      let alltask = e.alltask[0][0].alltask;
      axios
        .post("/handleCanchel/api", {
          idTask: idTask,
          alltask: alltask,
          pushItemID: e._id,
          adminID: e.adminIDTask,
          senderEmail: e.senderEmail,
          isChild:e.isChild,
          index:e.indexTask,
          task:alltask = e.alltask[0][0]
        })
        .then(function (response) {
          console.log(response);
          socket.emit("getNotifyEmit");
          socket.emit('getallTaskforUpdateServer');
          // handleDelete()
          update();
        })
        .catch(function (error) {
          console.log(error);
        });
    }

  };

  return (
    <>



      {
        (() => {
          let date = item.messageConfirm.split("T");
          let changeDateToCurrent = new Date(date)
        
let mount = ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"]
          let changetDate = changeDateToCurrent.getDate() + " " + mount[changeDateToCurrent.getMonth()] + " " + changeDateToCurrent.getFullYear()
  
          if (item.typenotify === "date") {

            return (
              <div className={getDarkModoe.ToggleDarkModeReducer.chekced ? "notifyCintDark" : "notifyCintLight"} key={index}>
                <div className="notifyCintChild">
                  {
                    (() => {
                      if (item.myAvatar) {
                        return <Avatar size='2xl'  src={item.myAvatar} />
                      } else {
                        return <Avatar size='2xl'  src='https://bit.ly/broken-link' />
                      }
                    })()
                  }

                  <div>
                    <h1>{item.senderName}</h1>

                    <p>Телефон</p>
                    <input type="text" name="" id="" value={item.senderTel} disabled />
                    <p>Почта</p>
                    <input type="text" name="" id="" value={item.senderEmail} disabled />
                  </div>
                  <div className="notifyBTnConfirm">

                    <DeeletNotifybtn item={item} index={index} />
                    {/* <ModalEditTask
                                editAllTask={item.alltask[0][0].alltask}
                                itemID={item.alltask[0][0]._id}
                                update={update}
                                allitem={item.alltask[0][0]}
                                data={item.alltask[0][0]}
                                handleGetNotify={handleGetNotify}
                              /> */}
                    {
                      (() => {
                        if (item.isChild == "false") {
                          return <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none" onClick={() => navigate("/getCurrentTask/" + item.eidtTaskID)}>
                            <circle cx="14.5" cy="14.5" r="14.5" fill="#F5F5F5" />
                            <path d="M16.2687 11.9393L17.0591 12.7299L9.27529 20.5147H8.48488V19.7242L16.2687 11.9393ZM19.3616 6.7666C19.1468 6.7666 18.9234 6.85253 18.7602 7.01579L17.188 8.58823L20.4097 11.8105L21.982 10.238C22.317 9.9029 22.317 9.36156 21.982 9.02645L19.9716 7.01579C19.7998 6.84393 19.585 6.7666 19.3616 6.7666ZM16.2687 9.50764L6.7666 19.011V22.2333H9.98838L19.4905 12.7299L16.2687 9.50764Z" fill="#3B79F6" />
                          </svg>
                        } else {
                          return <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none" onClick={() => navigate("/editChild/" + item.eidtTaskID + "/" + index)}>
                            <circle cx="14.5" cy="14.5" r="14.5" fill="#F5F5F5" />
                            <path d="M16.2687 11.9393L17.0591 12.7299L9.27529 20.5147H8.48488V19.7242L16.2687 11.9393ZM19.3616 6.7666C19.1468 6.7666 18.9234 6.85253 18.7602 7.01579L17.188 8.58823L20.4097 11.8105L21.982 10.238C22.317 9.9029 22.317 9.36156 21.982 9.02645L19.9716 7.01579C19.7998 6.84393 19.585 6.7666 19.3616 6.7666ZM16.2687 9.50764L6.7666 19.011V22.2333H9.98838L19.4905 12.7299L16.2687 9.50764Z" fill="#3B79F6" />
                          </svg>
                        }
                      })()
                    }
                  </div>
                </div>
                <div className="infoTaskAndBtn">
                  <div className="infoNotify">
                    <div>
                      <p>{
                        item.taskName ?
                          item.taskName
                          :
                          "Нет названия задачи"
                      }</p>
                      <p> {item.date}</p>
                    </div>
                    <p className="infoNotifyText"> Исполнитель запрашивает перенос даты окончания над задачей <br /> {item.taskName ? item.taskName : "Нет названия задачи"} на <b>{changetDate}</b> </p>



                  </div>
                  <div className="btnNotifyConfirm">

                    {(() => {
                      if (item.statusNotify == "Подтверждено") {
                        return (
                          <>
                            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none" onClick={() => handleApply(item)}>
                              <g filter="url(#filter0_d_694_3765)">
                                <circle cx="27" cy="25" r="24" fill="#42FF00" />
                              </g>
                              <rect x="15.4277" y="21.6934" width="16.9014" height="4.73239" transform="rotate(45 15.4277 21.6934)" fill="white" />
                              <path d="M42.4062 18.6162L24.0326 36.9898L20.6862 33.6435L39.0599 15.2699L42.4062 18.6162Z" fill="white" />
                              <defs>
                                <filter id="filter0_d_694_3765" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                  <feOffset dy="2" />
                                  <feGaussianBlur stdDeviation="1.5" />
                                  <feComposite in2="hardAlpha" operator="out" />
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_694_3765" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_694_3765" result="shape" />
                                </filter>
                              </defs>
                            </svg>

                            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none" onClick={() => handleCanhel(item)}>
                              <g filter="url(#filter0_d_694_3769)">
                                <circle cx="27" cy="25" r="24" fill="#353D49" />
                              </g>
                              <path d="M38.2412 17.8672L19.8675 36.2408L16.5212 32.8945L34.8949 14.5209L38.2412 17.8672Z" fill="white" />
                              <path d="M34.8945 36.2412L16.5209 17.8675L19.8673 14.5212L38.2408 32.8949L34.8945 36.2412Z" fill="white" />
                              <defs>
                                <filter id="filter0_d_694_3769" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                  <feOffset dy="2" />
                                  <feGaussianBlur stdDeviation="1.5" />
                                  <feComposite in2="hardAlpha" operator="out" />
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_694_3769" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_694_3769" result="shape" />
                                </filter>
                              </defs>
                            </svg>
                          </>
                        )
                      }
                      if (item.statusNotify == "Отменено") {
                        return (
                          <>


                            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none" onClick={() => handleApply(item)}>
                              <g filter="url(#filter0_d_694_3884)">
                                <path d="M51 25C51 38.2548 40.2548 49 27 49C13.7452 49 3 38.2548 3 25C3 11.7452 13.7452 1 27 1C40.2548 1 51 11.7452 51 25Z" fill="#353D49" />
                              </g>
                              <rect x="15.4277" y="21.6934" width="16.9014" height="4.73239" transform="rotate(45 15.4277 21.6934)" fill="white" />
                              <path d="M42.4062 18.6162L24.0326 36.9898L20.6862 33.6435L39.0599 15.2699L42.4062 18.6162Z" fill="white" />
                              <defs>
                                <filter id="filter0_d_694_3884" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                  <feOffset dy="2" />
                                  <feGaussianBlur stdDeviation="1.5" />
                                  <feComposite in2="hardAlpha" operator="out" />
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_694_3884" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_694_3884" result="shape" />
                                </filter>
                              </defs>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none" onClick={() => handleCanhel(item)}>
                              <g filter="url(#filter0_d_694_3870)">
                                <circle cx="27" cy="25" r="24" fill="#E62E7B" />
                              </g>
                              <path d="M38.2412 17.8672L19.8675 36.2408L16.5212 32.8945L34.8949 14.5209L38.2412 17.8672Z" fill="white" />
                              <path d="M34.8945 36.2412L16.5209 17.8675L19.8673 14.5212L38.2408 32.8949L34.8945 36.2412Z" fill="white" />
                              <defs>
                                <filter id="filter0_d_694_3870" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                  <feOffset dy="2" />
                                  <feGaussianBlur stdDeviation="1.5" />
                                  <feComposite in2="hardAlpha" operator="out" />
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_694_3870" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_694_3870" result="shape" />
                                </filter>
                              </defs>
                            </svg>
                          </>
                        )
                      } else {
                        return (
                          <>
                            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none" onClick={() => handleApply(item)}>
                              <g filter="url(#filter0_d_694_3866)">
                                <circle cx="27" cy="25" r="24" fill="#3B79F6" />
                              </g>
                              <rect x="15.4277" y="21.6934" width="16.9014" height="4.73239" transform="rotate(45 15.4277 21.6934)" fill="white" />
                              <path d="M42.4062 18.6162L24.0326 36.9898L20.6862 33.6435L39.0599 15.2699L42.4062 18.6162Z" fill="white" />
                              <defs>
                                <filter id="filter0_d_694_3866" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                  <feOffset dy="2" />
                                  <feGaussianBlur stdDeviation="1.5" />
                                  <feComposite in2="hardAlpha" operator="out" />
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_694_3866" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_694_3866" result="shape" />
                                </filter>
                              </defs>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none" onClick={() => handleCanhel(item)}>
                              <g filter="url(#filter0_d_694_3870)">
                                <circle cx="27" cy="25" r="24" fill="#E62E7B" />
                              </g>
                              <path d="M38.2412 17.8672L19.8675 36.2408L16.5212 32.8945L34.8949 14.5209L38.2412 17.8672Z" fill="white" />
                              <path d="M34.8945 36.2412L16.5209 17.8675L19.8673 14.5212L38.2408 32.8949L34.8945 36.2412Z" fill="white" />
                              <defs>
                                <filter id="filter0_d_694_3870" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                  <feOffset dy="2" />
                                  <feGaussianBlur stdDeviation="1.5" />
                                  <feComposite in2="hardAlpha" operator="out" />
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_694_3870" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_694_3870" result="shape" />
                                </filter>
                              </defs>
                            </svg>

                          </>
                        )
                      }
                    })()}
                  </div>

                </div>
                <div className="btnNotifyConfirmMobile">



                  <div>
                    <DeeletNotifybtn item={item} index={index} />
                    {/* <ModalEditTask
                                 editAllTask={item.alltask[0][0].alltask}
                                 itemID={item.alltask[0][0]._id}
                                 update={update}
                                 allitem={item.alltask[0][0]}
                                 data={item.alltask[0][0]}
                                 handleGetNotify={handleGetNotify}
                               /> */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none">
                      <circle cx="14.5" cy="14.5" r="14.5" fill="#F5F5F5" />
                      <path d="M16.2687 11.9393L17.0591 12.7299L9.27529 20.5147H8.48488V19.7242L16.2687 11.9393ZM19.3616 6.7666C19.1468 6.7666 18.9234 6.85253 18.7602 7.01579L17.188 8.58823L20.4097 11.8105L21.982 10.238C22.317 9.9029 22.317 9.36156 21.982 9.02645L19.9716 7.01579C19.7998 6.84393 19.585 6.7666 19.3616 6.7666ZM16.2687 9.50764L6.7666 19.011V22.2333H9.98838L19.4905 12.7299L16.2687 9.50764Z" fill="#3B79F6" />
                    </svg>
                  </div>
                  <div>
                    {(() => {
                      if (item.statusNotify == "Подтверждено") {
                        return (
                          <>
                            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none" onClick={() => handleApply(item)}>
                              <g filter="url(#filter0_d_694_3765)">
                                <circle cx="27" cy="25" r="24" fill="#42FF00" />
                              </g>
                              <rect x="15.4277" y="21.6934" width="16.9014" height="4.73239" transform="rotate(45 15.4277 21.6934)" fill="white" />
                              <path d="M42.4062 18.6162L24.0326 36.9898L20.6862 33.6435L39.0599 15.2699L42.4062 18.6162Z" fill="white" />
                              <defs>
                                <filter id="filter0_d_694_3765" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                  <feOffset dy="2" />
                                  <feGaussianBlur stdDeviation="1.5" />
                                  <feComposite in2="hardAlpha" operator="out" />
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_694_3765" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_694_3765" result="shape" />
                                </filter>
                              </defs>
                            </svg>

                            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none" onClick={() => handleCanhel(item)}>
                              <g filter="url(#filter0_d_694_3769)">
                                <circle cx="27" cy="25" r="24" fill="#353D49" />
                              </g>
                              <path d="M38.2412 17.8672L19.8675 36.2408L16.5212 32.8945L34.8949 14.5209L38.2412 17.8672Z" fill="white" />
                              <path d="M34.8945 36.2412L16.5209 17.8675L19.8673 14.5212L38.2408 32.8949L34.8945 36.2412Z" fill="white" />
                              <defs>
                                <filter id="filter0_d_694_3769" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                  <feOffset dy="2" />
                                  <feGaussianBlur stdDeviation="1.5" />
                                  <feComposite in2="hardAlpha" operator="out" />
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_694_3769" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_694_3769" result="shape" />
                                </filter>
                              </defs>
                            </svg>

                          </>
                        )
                      }
                      if (item.statusNotify == "Отменено") {
                        return (
                          <>


                            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none" onClick={() => handleApply(item)}>
                              <g filter="url(#filter0_d_694_3884)">
                                <path d="M51 25C51 38.2548 40.2548 49 27 49C13.7452 49 3 38.2548 3 25C3 11.7452 13.7452 1 27 1C40.2548 1 51 11.7452 51 25Z" fill="#353D49" />
                              </g>
                              <rect x="15.4277" y="21.6934" width="16.9014" height="4.73239" transform="rotate(45 15.4277 21.6934)" fill="white" />
                              <path d="M42.4062 18.6162L24.0326 36.9898L20.6862 33.6435L39.0599 15.2699L42.4062 18.6162Z" fill="white" />
                              <defs>
                                <filter id="filter0_d_694_3884" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                  <feOffset dy="2" />
                                  <feGaussianBlur stdDeviation="1.5" />
                                  <feComposite in2="hardAlpha" operator="out" />
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_694_3884" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_694_3884" result="shape" />
                                </filter>
                              </defs>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none" onClick={() => handleCanhel(item)}>
                              <g filter="url(#filter0_d_694_3870)">
                                <circle cx="27" cy="25" r="24" fill="#E62E7B" />
                              </g>
                              <path d="M38.2412 17.8672L19.8675 36.2408L16.5212 32.8945L34.8949 14.5209L38.2412 17.8672Z" fill="white" />
                              <path d="M34.8945 36.2412L16.5209 17.8675L19.8673 14.5212L38.2408 32.8949L34.8945 36.2412Z" fill="white" />
                              <defs>
                                <filter id="filter0_d_694_3870" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                  <feOffset dy="2" />
                                  <feGaussianBlur stdDeviation="1.5" />
                                  <feComposite in2="hardAlpha" operator="out" />
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_694_3870" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_694_3870" result="shape" />
                                </filter>
                              </defs>
                            </svg>
                          </>
                        )
                      } else {
                        return (
                          <>
                            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none" onClick={() => handleApply(item)}>
                              <g filter="url(#filter0_d_694_3866)">
                                <circle cx="27" cy="25" r="24" fill="#3B79F6" />
                              </g>
                              <rect x="15.4277" y="21.6934" width="16.9014" height="4.73239" transform="rotate(45 15.4277 21.6934)" fill="white" />
                              <path d="M42.4062 18.6162L24.0326 36.9898L20.6862 33.6435L39.0599 15.2699L42.4062 18.6162Z" fill="white" />
                              <defs>
                                <filter id="filter0_d_694_3866" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                  <feOffset dy="2" />
                                  <feGaussianBlur stdDeviation="1.5" />
                                  <feComposite in2="hardAlpha" operator="out" />
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_694_3866" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_694_3866" result="shape" />
                                </filter>
                              </defs>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none" onClick={() => handleCanhel(item)}>
                              <g filter="url(#filter0_d_694_3870)">
                                <circle cx="27" cy="25" r="24" fill="#E62E7B" />
                              </g>
                              <path d="M38.2412 17.8672L19.8675 36.2408L16.5212 32.8945L34.8949 14.5209L38.2412 17.8672Z" fill="white" />
                              <path d="M34.8945 36.2412L16.5209 17.8675L19.8673 14.5212L38.2408 32.8949L34.8945 36.2412Z" fill="white" />
                              <defs>
                                <filter id="filter0_d_694_3870" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                  <feOffset dy="2" />
                                  <feGaussianBlur stdDeviation="1.5" />
                                  <feComposite in2="hardAlpha" operator="out" />
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_694_3870" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_694_3870" result="shape" />
                                </filter>
                              </defs>
                            </svg>

                          </>
                        )
                      }
                    })()}
                  </div>
                </div>

              </div>
            )
          } else if (item.typenotify === "status") {
            return (
              <div className={getDarkModoe.ToggleDarkModeReducer.chekced ? "notifyCintDark" : "notifyCintLight"} key={index}>
                <div className="notifyCintChild">
                  {
                    (() => {
                      if (item.myAvatar) {
                        return <Avatar size='2xl' name='Segun Adebayo' src={item.myAvatar} />
                      } else {
                        return <Avatar size='2xl' name='Segun Adebayo' src='https://bit.ly/sage-adebayo' />
                      }
                    })()
                  }

                  <div>
                    <h1>{item.senderName}</h1>

                    <p>Телефон</p>
                    <input type="text" name="" id="" value={item.senderTel} disabled />
                    <p>Почта</p>
                    <input type="text" name="" id="" value={item.senderEmail} disabled />
                  </div>
                  <div className="notifyBTnConfirm">
                    <DeeletNotifybtn item={item} index={index} />
                    {/* <ModalEditTask
                                  editAllTask={item.alltask[0][0].alltask}
                                  itemID={item.alltask[0][0]._id}
                                  update={update}
                                  allitem={item.alltask[0][0]}
                                  data={item.alltask[0][0]}
                                  handleGetNotify={handleGetNotify}
                                /> */}
                    {
                      (() => {
                        if (item.isChild == "false") {
                          return <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none" onClick={() => navigate("/getCurrentTask/" + item.eidtTaskID)}>
                            <circle cx="14.5" cy="14.5" r="14.5" fill="#F5F5F5" />
                            <path d="M16.2687 11.9393L17.0591 12.7299L9.27529 20.5147H8.48488V19.7242L16.2687 11.9393ZM19.3616 6.7666C19.1468 6.7666 18.9234 6.85253 18.7602 7.01579L17.188 8.58823L20.4097 11.8105L21.982 10.238C22.317 9.9029 22.317 9.36156 21.982 9.02645L19.9716 7.01579C19.7998 6.84393 19.585 6.7666 19.3616 6.7666ZM16.2687 9.50764L6.7666 19.011V22.2333H9.98838L19.4905 12.7299L16.2687 9.50764Z" fill="#3B79F6" />
                          </svg>
                        } else {
                          return <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none" onClick={() => navigate("/editChild/" + item.eidtTaskID + "/" + index)}>
                            <circle cx="14.5" cy="14.5" r="14.5" fill="#F5F5F5" />
                            <path d="M16.2687 11.9393L17.0591 12.7299L9.27529 20.5147H8.48488V19.7242L16.2687 11.9393ZM19.3616 6.7666C19.1468 6.7666 18.9234 6.85253 18.7602 7.01579L17.188 8.58823L20.4097 11.8105L21.982 10.238C22.317 9.9029 22.317 9.36156 21.982 9.02645L19.9716 7.01579C19.7998 6.84393 19.585 6.7666 19.3616 6.7666ZM16.2687 9.50764L6.7666 19.011V22.2333H9.98838L19.4905 12.7299L16.2687 9.50764Z" fill="#3B79F6" />
                          </svg>
                        }
                      })()
                    }

                  </div>
                </div>
                <div className="infoTaskAndBtn">
                  <div className="infoNotify">
                    <div>
                      <p>{
                        item.taskName ?
                          item.taskName
                          :
                          "Нет названия задачи"
                      }</p>
                      <p> {item.date}</p>
                    </div>
                    <p className="infoNotifyText">  Исполнитель просит подтвердить выполнение задачи    #{item.taskName ? item.taskName : "Нет названия задачи"} </p>



                  </div>
                  <div className="btnNotifyConfirm">


                    {(() => {
                      if (item.statusNotify == "Подтверждено") {
                        return (
                          <>
                            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none" onClick={() => handleApply(item)}>
                              <g filter="url(#filter0_d_694_3765)">
                                <circle cx="27" cy="25" r="24" fill="#42FF00" />
                              </g>
                              <rect x="15.4277" y="21.6934" width="16.9014" height="4.73239" transform="rotate(45 15.4277 21.6934)" fill="white" />
                              <path d="M42.4062 18.6162L24.0326 36.9898L20.6862 33.6435L39.0599 15.2699L42.4062 18.6162Z" fill="white" />
                              <defs>
                                <filter id="filter0_d_694_3765" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                  <feOffset dy="2" />
                                  <feGaussianBlur stdDeviation="1.5" />
                                  <feComposite in2="hardAlpha" operator="out" />
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_694_3765" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_694_3765" result="shape" />
                                </filter>
                              </defs>
                            </svg>

                            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none" onClick={() => handleCanhel(item)}>
                              <g filter="url(#filter0_d_694_3769)">
                                <circle cx="27" cy="25" r="24" fill="#353D49" />
                              </g>
                              <path d="M38.2412 17.8672L19.8675 36.2408L16.5212 32.8945L34.8949 14.5209L38.2412 17.8672Z" fill="white" />
                              <path d="M34.8945 36.2412L16.5209 17.8675L19.8673 14.5212L38.2408 32.8949L34.8945 36.2412Z" fill="white" />
                              <defs>
                                <filter id="filter0_d_694_3769" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                  <feOffset dy="2" />
                                  <feGaussianBlur stdDeviation="1.5" />
                                  <feComposite in2="hardAlpha" operator="out" />
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_694_3769" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_694_3769" result="shape" />
                                </filter>
                              </defs>
                            </svg>

                          </>
                        )
                      }
                      if (item.statusNotify == "Отменено") {
                        return (
                          <>


                            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none" onClick={() => handleApply(item)}>
                              <g filter="url(#filter0_d_694_3884)">
                                <path d="M51 25C51 38.2548 40.2548 49 27 49C13.7452 49 3 38.2548 3 25C3 11.7452 13.7452 1 27 1C40.2548 1 51 11.7452 51 25Z" fill="#353D49" />
                              </g>
                              <rect x="15.4277" y="21.6934" width="16.9014" height="4.73239" transform="rotate(45 15.4277 21.6934)" fill="white" />
                              <path d="M42.4062 18.6162L24.0326 36.9898L20.6862 33.6435L39.0599 15.2699L42.4062 18.6162Z" fill="white" />
                              <defs>
                                <filter id="filter0_d_694_3884" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                  <feOffset dy="2" />
                                  <feGaussianBlur stdDeviation="1.5" />
                                  <feComposite in2="hardAlpha" operator="out" />
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_694_3884" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_694_3884" result="shape" />
                                </filter>
                              </defs>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none" onClick={() => handleCanhel(item)}>
                              <g filter="url(#filter0_d_694_3870)">
                                <circle cx="27" cy="25" r="24" fill="#E62E7B" />
                              </g>
                              <path d="M38.2412 17.8672L19.8675 36.2408L16.5212 32.8945L34.8949 14.5209L38.2412 17.8672Z" fill="white" />
                              <path d="M34.8945 36.2412L16.5209 17.8675L19.8673 14.5212L38.2408 32.8949L34.8945 36.2412Z" fill="white" />
                              <defs>
                                <filter id="filter0_d_694_3870" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                  <feOffset dy="2" />
                                  <feGaussianBlur stdDeviation="1.5" />
                                  <feComposite in2="hardAlpha" operator="out" />
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_694_3870" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_694_3870" result="shape" />
                                </filter>
                              </defs>
                            </svg>
                          </>
                        )
                      } else {
                        return (
                          <>
                            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none" onClick={() => handleApply(item)}>
                              <g filter="url(#filter0_d_694_3866)">
                                <circle cx="27" cy="25" r="24" fill="#3B79F6" />
                              </g>
                              <rect x="15.4277" y="21.6934" width="16.9014" height="4.73239" transform="rotate(45 15.4277 21.6934)" fill="white" />
                              <path d="M42.4062 18.6162L24.0326 36.9898L20.6862 33.6435L39.0599 15.2699L42.4062 18.6162Z" fill="white" />
                              <defs>
                                <filter id="filter0_d_694_3866" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                  <feOffset dy="2" />
                                  <feGaussianBlur stdDeviation="1.5" />
                                  <feComposite in2="hardAlpha" operator="out" />
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_694_3866" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_694_3866" result="shape" />
                                </filter>
                              </defs>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none" onClick={() => handleCanhel(item)}>
                              <g filter="url(#filter0_d_694_3870)">
                                <circle cx="27" cy="25" r="24" fill="#E62E7B" />
                              </g>
                              <path d="M38.2412 17.8672L19.8675 36.2408L16.5212 32.8945L34.8949 14.5209L38.2412 17.8672Z" fill="white" />
                              <path d="M34.8945 36.2412L16.5209 17.8675L19.8673 14.5212L38.2408 32.8949L34.8945 36.2412Z" fill="white" />
                              <defs>
                                <filter id="filter0_d_694_3870" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                  <feOffset dy="2" />
                                  <feGaussianBlur stdDeviation="1.5" />
                                  <feComposite in2="hardAlpha" operator="out" />
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_694_3870" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_694_3870" result="shape" />
                                </filter>
                              </defs>
                            </svg>

                          </>
                        )
                      }
                    })()}
                  </div>
                </div>
                {/* btnNotifyConfirmMobile ======================================= */}
                <div className="btnNotifyConfirmMobile">



                  <div>
                    <DeeletNotifybtn item={item} index={index} />
                    {/* <ModalEditTask
                                  editAllTask={item.alltask[0][0].alltask}
                                  itemID={item.alltask[0][0]._id}
                                  update={update}
                                  allitem={item.alltask[0][0]}
                                  data={item.alltask[0][0]}
                                  handleGetNotify={handleGetNotify}
                                /> */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none">
                      <circle cx="14.5" cy="14.5" r="14.5" fill="#F5F5F5" />
                      <path d="M16.2687 11.9393L17.0591 12.7299L9.27529 20.5147H8.48488V19.7242L16.2687 11.9393ZM19.3616 6.7666C19.1468 6.7666 18.9234 6.85253 18.7602 7.01579L17.188 8.58823L20.4097 11.8105L21.982 10.238C22.317 9.9029 22.317 9.36156 21.982 9.02645L19.9716 7.01579C19.7998 6.84393 19.585 6.7666 19.3616 6.7666ZM16.2687 9.50764L6.7666 19.011V22.2333H9.98838L19.4905 12.7299L16.2687 9.50764Z" fill="#3B79F6" />
                    </svg>
                  </div>
                  <div>
                    {(() => {
                      if (item.statusNotify == "Подтверждено") {
                        return (
                          <>
                            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none" onClick={() => handleApply(item)}>
                              <g filter="url(#filter0_d_694_3765)">
                                <circle cx="27" cy="25" r="24" fill="#42FF00" />
                              </g>
                              <rect x="15.4277" y="21.6934" width="16.9014" height="4.73239" transform="rotate(45 15.4277 21.6934)" fill="white" />
                              <path d="M42.4062 18.6162L24.0326 36.9898L20.6862 33.6435L39.0599 15.2699L42.4062 18.6162Z" fill="white" />
                              <defs>
                                <filter id="filter0_d_694_3765" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                  <feOffset dy="2" />
                                  <feGaussianBlur stdDeviation="1.5" />
                                  <feComposite in2="hardAlpha" operator="out" />
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_694_3765" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_694_3765" result="shape" />
                                </filter>
                              </defs>
                            </svg>

                            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none" onClick={() => handleCanhel(item)}>
                              <g filter="url(#filter0_d_694_3769)">
                                <circle cx="27" cy="25" r="24" fill="#353D49" />
                              </g>
                              <path d="M38.2412 17.8672L19.8675 36.2408L16.5212 32.8945L34.8949 14.5209L38.2412 17.8672Z" fill="white" />
                              <path d="M34.8945 36.2412L16.5209 17.8675L19.8673 14.5212L38.2408 32.8949L34.8945 36.2412Z" fill="white" />
                              <defs>
                                <filter id="filter0_d_694_3769" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                  <feOffset dy="2" />
                                  <feGaussianBlur stdDeviation="1.5" />
                                  <feComposite in2="hardAlpha" operator="out" />
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_694_3769" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_694_3769" result="shape" />
                                </filter>
                              </defs>
                            </svg>

                          </>
                        )
                      }
                      if (item.statusNotify == "Отменено") {
                        return (
                          <>


                            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none" onClick={() => handleApply(item)}>
                              <g filter="url(#filter0_d_694_3884)">
                                <path d="M51 25C51 38.2548 40.2548 49 27 49C13.7452 49 3 38.2548 3 25C3 11.7452 13.7452 1 27 1C40.2548 1 51 11.7452 51 25Z" fill="#353D49" />
                              </g>
                              <rect x="15.4277" y="21.6934" width="16.9014" height="4.73239" transform="rotate(45 15.4277 21.6934)" fill="white" />
                              <path d="M42.4062 18.6162L24.0326 36.9898L20.6862 33.6435L39.0599 15.2699L42.4062 18.6162Z" fill="white" />
                              <defs>
                                <filter id="filter0_d_694_3884" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                  <feOffset dy="2" />
                                  <feGaussianBlur stdDeviation="1.5" />
                                  <feComposite in2="hardAlpha" operator="out" />
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_694_3884" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_694_3884" result="shape" />
                                </filter>
                              </defs>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none" onClick={() => handleCanhel(item)}>
                              <g filter="url(#filter0_d_694_3870)">
                                <circle cx="27" cy="25" r="24" fill="#E62E7B" />
                              </g>
                              <path d="M38.2412 17.8672L19.8675 36.2408L16.5212 32.8945L34.8949 14.5209L38.2412 17.8672Z" fill="white" />
                              <path d="M34.8945 36.2412L16.5209 17.8675L19.8673 14.5212L38.2408 32.8949L34.8945 36.2412Z" fill="white" />
                              <defs>
                                <filter id="filter0_d_694_3870" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                  <feOffset dy="2" />
                                  <feGaussianBlur stdDeviation="1.5" />
                                  <feComposite in2="hardAlpha" operator="out" />
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_694_3870" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_694_3870" result="shape" />
                                </filter>
                              </defs>
                            </svg>
                          </>
                        )
                      } else {
                        return (
                          <>
                            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none" onClick={() => handleApply(item)}>
                              <g filter="url(#filter0_d_694_3866)">
                                <circle cx="27" cy="25" r="24" fill="#3B79F6" />
                              </g>
                              <rect x="15.4277" y="21.6934" width="16.9014" height="4.73239" transform="rotate(45 15.4277 21.6934)" fill="white" />
                              <path d="M42.4062 18.6162L24.0326 36.9898L20.6862 33.6435L39.0599 15.2699L42.4062 18.6162Z" fill="white" />
                              <defs>
                                <filter id="filter0_d_694_3866" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                  <feOffset dy="2" />
                                  <feGaussianBlur stdDeviation="1.5" />
                                  <feComposite in2="hardAlpha" operator="out" />
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_694_3866" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_694_3866" result="shape" />
                                </filter>
                              </defs>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none" onClick={() => handleCanhel(item)}>
                              <g filter="url(#filter0_d_694_3870)">
                                <circle cx="27" cy="25" r="24" fill="#E62E7B" />
                              </g>
                              <path d="M38.2412 17.8672L19.8675 36.2408L16.5212 32.8945L34.8949 14.5209L38.2412 17.8672Z" fill="white" />
                              <path d="M34.8945 36.2412L16.5209 17.8675L19.8673 14.5212L38.2408 32.8949L34.8945 36.2412Z" fill="white" />
                              <defs>
                                <filter id="filter0_d_694_3870" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                  <feOffset dy="2" />
                                  <feGaussianBlur stdDeviation="1.5" />
                                  <feComposite in2="hardAlpha" operator="out" />
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_694_3870" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_694_3870" result="shape" />
                                </filter>
                              </defs>
                            </svg>

                          </>
                        )
                      }
                    })()}
                  </div>
                </div>
              </div>
            )
          }
        })()
      }
    </>
  );
}
